<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}
</style>

<div class="bg">
  <div class="title-signup">What's your name?</div>
  <div class="margin"><input type="text" bind:value="{name}" placeholder="Your Name" on:keyup="{check}"></div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";


import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
    Signup.load();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("nameSaved", false);
  // Signup.saveToPersonalObject("name", "");
  nameSaved = Signup.getPersonalObject("nameSaved");
  name = Signup.getPersonalObject("name");
  
  if (nameSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let name = "";
let nameSaved = false;
let nextDisabled = true;


function check(e) {
  nameSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    Validate.name(name);
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (nameSaved == false) {
    name = Normalize.name(name);
    await Signup.saveToPersonalObject("name", name);
    await Signup.saveToPersonalObject("nameSaved", true);
    // since we haven't generated asymm keys yet, we'll wait to save this
    // await Signup.saveMe("name");
  }
  push("/signup/profile/personal/email");
}


</script>